import useAwards from '@hooks/models/useAwards'
import useCountries from '@hooks/models/useCountries'
import useJuries from '@hooks/models/useJuries'
import useOrganizations from '@hooks/models/useOrganizations'
import useSections from '@hooks/models/useSections'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'
import { useParams } from 'react-router-dom'
import SalonAdd from './components/Add'
import SalonEdit from './components/Edit'
import SalonEditContext from './context'

export default function SalonEditPage() {
    const { id } = useParams<{ id?: string }>()
    useMainTemplate({ category: "salons" })

    const { options: countries } = useCountries()
    const { options: sections } = useSections()
    const { options: organizations } = useOrganizations()
    const { options: awards } = useAwards()

    if (!countries || !sections || !organizations || !awards)
        return null 

    return (
        <SalonEditContext.Provider value={{ countries, sections, organizations, awards }}>
            {id ? <SalonEdit id={id} /> : <SalonAdd />}
        </SalonEditContext.Provider>
    )
}

// TYPES
export type PatronageWithId = Partial<Interfaces.Patronage> & Pick<Interfaces.Patronage, "id">
export type JuryWithId = Partial<Interfaces.Jury> & Pick<Interfaces.Jury, "id">
export type AwardWithId = PartialExcept<Interfaces.Award, "id">